export default {
      id: "oc-res-offline-export-usage",
      viewBox: "0 0 1317 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-offline-export",
      toString: function () {
        return this.url;
      }
    }